import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Health {
  status: 'ok' | 'degraded';
  environment: string;
  checks: Record<string, 'ok' | 'fail'>;
  time: string;
}

@Injectable({ providedIn: 'root' })
export class HealthService {
  private readonly http = inject(HttpClient);

  get(): Observable<Health> {
    return this.http.get<Health>(`${environment.apiBaseUrl}/health`);
  }
}
